module.exports = __webpack_public_path__ + "img/time@2x.b4c3f2e0.png";